const serviceRoot = 'https://ipac.ecosphere.fws.gov/location/api/';

export const IpacEndpoints = {
  getSpecies: () => `${serviceRoot}resources`,
};
